import { render, staticRenderFns } from "./EnlargedImagePopup.vue?vue&type=template&id=6af6a522&scoped=true&"
import script from "./EnlargedImagePopup.vue?vue&type=script&lang=js&"
export * from "./EnlargedImagePopup.vue?vue&type=script&lang=js&"
import style0 from "./EnlargedImagePopup.vue?vue&type=style&index=0&id=6af6a522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af6a522",
  null
  
)

export default component.exports